const productPageWrapperEl = document.querySelector(".product-page-wrapper")
if (productPageWrapperEl) {
  if (!!localStorage.getItem("auto_open_product_form_register")) {
    setTimeout(() => {
      productPageWrapperEl.style.opacity = 1
    }, 1000 + 1500)
  } else if (!!localStorage.getItem("auto_open_product_form_login")) {
    setTimeout(() => {
      productPageWrapperEl.style.opacity = 1
    }, 1000)
    
  } else {
    productPageWrapperEl.style.opacity = 1
  }
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);
function getButtonHeight() {
  let h = $(".save-continue-wrapper.fixed:not(.relative)").outerHeight(true) - $(".save-continue-wrapper.fixed:not(.relative)").outerHeight(true) * 0.01;
  document.documentElement.style.setProperty('--bh', `${h}px`);

}
function getVariantHeight() {
  let h = $(".mobile-variants-options-wrapper").outerHeight(true) * 0.01 * 100;
  document.documentElement.style.setProperty('--variants', `-${h}px`);
}
function getBoxHeight() {
  let h = $(".box-wrapper").outerHeight(true);
  document.documentElement.style.setProperty('--box-wrapper', `${h}px`);
}
// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  // getButtonHeight();
  getVariantHeight();
});
function changeType() {
  $('[data-type="password"]').attr('type', 'password');
  $('[data-type="email"]').attr('type', 'email');
}
getVariantHeight();
getBoxHeight();
getButtonHeight();
setTimeout(getBoxHeight,100);
// storeLoggedIn
function storeLoggedIn(){
  // remove everything
  localStorage.removeItem('property');

  // then save everything
  // this is anti-pattern
  // need to find some alternative
  storeProperyData();

  // then store is first isLoggedIn

  localStorage.setItem('login_success',true);

}
// complete register form
function showWelcome() {
  if (localStorage.getItem('showWelcome') === "true" && customerData.id) {
    app.activeForm = 'welcome';
    app.open();
    localStorage.removeItem("showWelcome");
    // greencheckAnimation();
    setTimeout(greencheckAnimation,50);
    // auto close
    setTimeout(app.close,5000);
    
    
  }
}
// make the subscription
function registerSubscription() {
  // V2: newsletter consent is saved by the complete-profile step
  if (useSizesV2()) {
    return;
  }

  if (localStorage.getItem('registerSubscribe') === "true" && customerData.id){
    localStorage.removeItem("registerSubscribe");
    $.ajax({
      type: 'POST',
      url: `http://themebuz.com/subscription/public/customer/${customerData.id}/update`,
      dataType: 'json',

      success: function(res) {
        // console.log('customer subscription updated successfully');
        // console.log(res)
      },
      error: function(request, status, error) {
        // if it's not last one Move Along else update the cart number with the current quantity
        console.log(request.responseText);
        console.log("error");
      }
    });
  }
}
// called after some interval
setTimeout(function () {
  // changeType();
  registerSubscription();
},300);
// setTimeout(registerSubscription,300);

setTimeout(showWelcome,1500);

// remove cart body and update empty cart
function updateCartBody() {
  $(".quick-cart__items .cart__item").remove();
  $(".quick-cart__footer").addClass("hide");
  $(".quick-cart__items").html('<p class="quick-cart__empty-state">Your cart is currently empty.</p>');
}
// update total quantity
function totalCart(qty = 0) {
  $(".quick-cart__indicator-inner").html(qty);


  if (!qty) {
    updateCartBody();
  }
}
// remove all cart

function clearAllCart(redirect = false) {
  $.ajax({
    type: "POST",
    url: '/cart/clear.js',
    data: '',
    dataType: 'json',
    success: function() {
       totalCart(0);
       if(redirect) {
         window.location = "/account/logout";
       }
    },
    error: function(XMLHttpRequest, textStatus) {
      /* error code */
    }
  });
}
if (!customerData.isLoggedIn && cartObj === '0') {
  totalCart();
  clearAllCart();
}

$(".account__logout > a").on("click", function(e){
  e.preventDefault();
  // console.log("logout");
  clearAllCart(true);
});
// remove single cart item
function cartRemove(self,key) {
  // console.log(key);
  $(self).closest('.cart__item').remove();
  Shopify.theme.cart.removeItem(key).then(state => {
    // console.log(state);
    $(".js-subtotal").html(Shopify.formatMoney(state.items_subtotal_price));
    totalCart(state.items.length);
  });
}
var metaItems = document.querySelectorAll('.product-meta-item');
var closeBtns = document.querySelectorAll('.close-btn');
var productSlider = $('.mh-media-slider');
var mhProductJSON = {};
if (!!$(".mh-product-json").length) {
  mhProductJSON = JSON.parse($(".mh-product-json").html())
}

function tshirt(addExtraHeight, isDesktop) {
  if (window.preventProductScroll) return
  // animated first image to top
  // scroll and display the featured_media
  // setTimeout(function () {
  //   $("html, body").animate({ scrollTop: $('.fixed-scroll').offset().top -70 }, 500);
  // },500);
  if (addExtraHeight && window.Shopify?.Custom?.initialsExtraHeight) {
    if (isDesktop) {
      // TODO
    } else {
      document.querySelector(".template-product .mh-media-slider").style.height = `calc(100vh - 75px - var(--bh,136.31112px) + ${window.Shopify?.Custom?.initialsExtraHeightMobile || window.Shopify?.Custom?.initialsExtraHeight}vw)`;
    }
  }
  setTimeout(function() {
    if (addExtraHeight && window.Shopify?.Custom?.initialsExtraHeight) {
      if (isDesktop) {
        // TODO
        window.scrollTo(0, $(".fixed-scroll").offset().top - 70 + (0.65 * window.innerWidth * (window.Shopify?.Custom?.initialsExtraHeight) * 0.01)); 
      } else {
        window.scrollTo(0, 200000); // TTT
      }
    } else {
      window.scrollTo(0, $(".fixed-scroll").offset().top - 70); 
    }
  }, 300);
}

function getSelectedVariant() {
  var arr = [];
  $(".choose-item.active .choose-item-option").map((i, o) => arr.push($(o).html().trim()));
  return arr;
}
function changeUrl(vid) {
  const url = new URL(window.location);
  window.history.pushState({},'',`${url.origin}${url.pathname}?variant=${vid}`)
}
function changeVariant() {
  var variant = Shopify.theme.product.getVariantFromOptionArray(mhProductJSON, getSelectedVariant())
  // console.log({variant});
  // $(productSlider).slick('slickGoTo',4);
  /*  var imgId = variant.featured_media.id;
    var idx = $(`[data-media-id='${imgId}']`).data('slick-index');
    console.log("idx: " + idx);
    $(productSlider).slick('slickGoTo',idx)*/
    try {
      var imgId = variant.featured_media.id;
       var idx = $(`[data-media-id='${imgId}']`).data('slick-index');
       // console.log("idx: " + idx);
       $(productSlider).slick('slickGoTo',idx)
    } catch (e) {
      console.log(e);
    }
    if (variant.option1) {
      $("#Option1").val(variant.option1).trigger("change")
    }
    if (variant.option2) {
      $("#Option2").val(variant.option2).trigger("change")
    }
    if (variant.option3) {
      $("#Option3").val(variant.option3).trigger("change")
    }
    $("#variant-selector").val(variant.id);
    // console.log("changeVariant");
    // changeUrl(variant.id);

    storeProperyData();
    // console.log(variant.price)
    document.querySelector("[data-product-price]").innerText = Shopify.formatMoney(variant.price)
}

/* onclick conversion */
function modifySVG() {
  const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");
  const style = document.createElementNS("http://www.w3.org/2000/svg", "style");
  style.type = "text/css";
  // prettier-ignore
  style.innerHTML = `${svgFont}`;
  var newSvg = $(".mh-inital-placeholder svg");
  newSvg.find("defs").remove();
  defs.appendChild(style);
  newSvg.append(defs)
}

function base64(val = '') {
  try {
    var svg = document.querySelector('svg#Livello_1'),
      canvas = document.createElement('canvas'),
      body = document.getElementsByTagName('body')[0],
      canvasTmp,
      svg_xml,
      ctx,
      img;
    document.querySelector('.mh-inital-placeholder svg .st0').innerHTML = val;
    // if our "svg" doesn't have 'xmlns' attribute we must add it
    //svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

    canvas.id = 'canvas';
    canvas.width = svg.getBoundingClientRect().width;
    canvas.height = svg.getBoundingClientRect().height;

    body.appendChild(canvas);
    canvasTmp = document.getElementById('canvas');

    /* Time to play ;) */

    // https://developer.mozilla.org/en/XMLSerializer
    svg_xml = (new XMLSerializer()).serializeToString(svg);
    ctx = canvasTmp.getContext('2d');

    // JavaScript (HTML) image
    img = new Image();

    img.onload = function() {
      ctx.drawImage(img, 0, 0);
    };

    // https://developer.mozilla.org/en/DOM/window.btoa
    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg_xml)));

    // img.src - contains base64 URI from svg
    // console.log(img.src);
    $(".product-image-layer").css('background-image', 'url(' + img.src + ')');
    //remove temporary canvas
    canvasTmp.remove();

    //Check in browsers
    //body.appendChild(img);
  } catch (e) {
    console.log("no text value here");
  }
}
modifySVG();
//  product image


/*image slider*/
var imageSlider = {
  init: function () {
    $(productSlider).slick({
      infinite: false,
      dots: false,
      arrows: false,
      adaptiveHeight: false,
      draggable: false,
      fade: true
    });
  },
  unload: function (target = ".product-images") {
    if ($(productSlider).hasClass("slick-initialized")) {
      $(productSlider).slick("destroy");
    }
  },
  reinit:function () {
    this.unload();
    this.init();
  }
};
imageSlider.init();

metaItems.forEach((metaItem) => {
  metaItem.addEventListener('click', function() {

    $(".mh-product-custom").addClass('clicked');
    $(".product__media-action,.product__media").addClass('active');

    $(this).addClass('active').siblings('.clicked').removeClass('active');
    var target = $(this).data("target");
    $(".mh-product-items").hide();
    $(target).show();
    $(".active-title").html(
      $(this).find('.btn-text').html()
    )
    metaItems.forEach((eachElement) => {
      eachElement.classList.add('clicked');
    })

    // tshirt();
    const isInitials = target === ".fourth-product-items"
    tshirt(isInitials, true); // TTT
  })
})
$(".next-btn").on('click', function(event) {
  event.preventDefault();
  var t = $(".product-meta-fit.clicked.active").next();
  if (t.length) {
    t.trigger('click');
  } else {
    $(".summary-btn").trigger('click');
  }
});
$(".summary-btn").on('click', function(event) {
  event.preventDefault();
  tshirt();
  $(".mh-product-custom").removeClass('clicked');
  $(metaItems).removeClass('clicked active');
  $(".product__media-action,.product__media").removeClass('active');
});
$(".choose-item").on('click', function(event) {
  event.preventDefault();

  var text = $(this).find('.choose-item-option').text();
  var target = $(this).data('target');
  $(this).addClass('active').siblings('.choose-item').removeClass('active');
  $(target).text(text);
  $(target).closest('.stay-right').find(".first-option-icon").attr('src', $(this).data('img'));

  changeVariant();
});
$(function() {
  var textLimit = 6;
  $("#input-type1").on('keyup', function(e) {
    var val = $(this).val();
    // console.log(val)
    // base64(val);
     applyStyle();

    $('.engrave-text,.write-engrave,.mobile-initial-placeholder').html($("#input-type1").val());
    selectedCase
    try {
      const isUpper = selectedCase === "uppercase"
      if (isUpper) {
        $('.input-engrave').val($("#input-type1").val().toUpperCase());
      } else {
        $('.input-engrave').val($("#input-type1").val().toLowerCase());
      }
      $('#mobile-input').val($("#input-type1").val());
    } catch(error) {
      console.error(error)
      $('.input-engrave,#mobile-input').val($("#input-type1").val());
    }
    
    if (val.length == 0) {
      $('.write-engrave,.mobile-initial-placeholder').html('NO');
      $('.input-engrave').val('NO');
      applyStyle(false);

    }
  })
});
$(function() {
  var drawerOpenBtns = document.querySelectorAll('.appointment_btn');
  var drawerContainer = document.querySelector('.mh-appointment_drawer');
  var drawerCloseBtn = document.querySelector('.mh-drawer_close_btn');
  var btnDItem = document.querySelectorAll('.reservebtn');
  var drawerFirst = document.querySelector('.mh-appointment_drawer .first_drawer');
  var drawerSecond = document.querySelector('.mh-appointment_drawer .second-drawer');
  var drawerThird = document.querySelector('.mh-appointment_drawer .third-drawer');
  var drawerBackBtn = document.querySelector('.drawer_back_btn');

  function showHide(visible = 'show') {
    if (visible == 'show') {
      $(".mh-appointment_drawer .second-drawer .drawer_bottom").addClass('op');
      $(".drawer-loader").show();
    } else {
      $(".mh-appointment_drawer .second-drawer .drawer_bottom").removeClass('op');
      $(".drawer-loader").hide();
    }
  }

  function appointmentOpen() {
    drawerContainer.classList.add('is_open')
    document.querySelector("body").classList.add('is_body_open');
  }
  drawerOpenBtns.forEach((drawerOpenBtn) => {
    drawerOpenBtn.addEventListener('click', () => {
      appointmentOpen();
    })
  });

  $("#shopify-section-1602299518294 a.slideshow__link.bttn").on('click', function(event) {
    event.preventDefault();
    appointmentOpen();
  });

  const anotherS = document.querySelector("#shopify-section-c57ef13d-c67a-40b5-ac42-9f58924aa458 .text-columns__content:first-child a:last-child")
  if (anotherS) {
    anotherS.addEventListener("click", function(e) {
      e.preventDefault();
      appointmentOpen();
    })
    
  }
  
  const allS = document.querySelectorAll(".open-appointment").forEach(el => {
    el.addEventListener("click", function(e) {
      e.preventDefault();
      appointmentOpen();
    })
  })

  try {
    drawerCloseBtn.addEventListener('click', () => {
      drawerContainer.classList.remove('is_open');
      drawerContainer.classList.remove('contact-submit');
      document.querySelector("body").classList.remove('is_body_open');
      drawerFirst.classList.remove('closed');
      drawerSecond.classList.add('closed');
      drawerThird.classList.add('closed');
      drawerThird.classList.remove('submit-form');
      drawerThird.classList.remove('active');
      drawerBackBtn.classList.remove('is_active');
    });
    drawerSecond.classList.add('closed');
    drawerThird.classList.add('closed');
  } catch (e) {
    console.log(e);
  }


  function filterTime(currentDate) {
    setTimeout(function() {
      // console.log("delay ");
      var currentData = _.filter(calendarEvents, ["appointmentDate", currentDate]);
      var currentTime = _.map(currentData, 'appointmentTime');
      $(".appointment_time").addClass("avilable");
      if (typeof currentTime == "string") {
        // console.log(currentTime);
        currentTime.forEach(t => {
          // console.log(`[data-time='${t}']`)
          $(`[data-time='${t}']`).removeClass("avilable");
        })

      } else {
        // console.log("its object");
        // console.log(currentTime);
        var ct = currentTime.flat();
        ct.forEach(t => {
          // console.log(`[data-time='${t}']`)
          $(`[data-time='${t}']`).removeClass("avilable");
        })
        // console.log(currentTime);
      }

    }, 500)
  }

  function getDay() {
    return $("button.slider_item_btn.avilable.is_active span.selected-date").html()
  }

  function isToday(day) {
    // console.log(day);
    $(".appointment_time").removeClass("disabled");
    if (getDay() == dayjs().format("ddd DD MMM, YYYY")) {
      // console.log("This is today");
      var h = dayjs().get('hours') < 10 ? "0" + dayjs().get('hours') : dayjs().get('hours');
      var m = dayjs().get('minute');
      var hhmm = h + ":" + m;
      // console.log(hhmm);
      // console.log("this dayjs: " + dayjs().format("HH:MM"));
      $(".appointment_list li button").each((i, d) => {
        if ($(d).data('time') < hhmm) {
          // console.log($(d).data('time'));
          $(d).addClass("disabled");

        }
      })

    }
  }

  $(btnDItem).on('click', function(event) {
    event.preventDefault();
    showHide();
    isToday(getDay());
    var name = $(this).data('name');
    calendarEvents = [];

    db
      .collection("Calendario")
      .where('appointmentWith', '==', name)
      .limit(100)
      .get()
      .then(function(querySnapshot) {
        querySnapshot.forEach(function(doc) {
          calendarEvents.push(doc.data());
        });
      })
      .then(function() {
        // console.log("data get completed");
        // console.log(calendarEvents);
        filterTime(getDay());
        showHide('hide');
      })
      .catch(function() {
        console.log("firebase went wrong");
      })

    drawerFirst.classList.add('closed');

    // drawerSecond.classList.remove('closed');
    $(drawerSecond).toggleClass('closed active')
    drawerBackBtn.classList.add('is_active');
    var dimg = $(this).siblings('span').find('.drawer_img img').attr('src');

    $("#appoinrment-name").val(name);
    $(".second-drawer .drawer_img img").attr('src', dimg);

    // console.log($(this).data('name'));

  });
  drawerBackBtn.addEventListener('click', () => {
    if ($(drawerSecond).hasClass('active')) {
      drawerFirst.classList.remove('closed');
      $(drawerSecond).toggleClass('closed active');
      drawerBackBtn.classList.remove('is_active');
    } else if ($(drawerThird).hasClass('active')) {
      $(drawerThird).toggleClass('closed active');
      $(drawerSecond).toggleClass('closed active')
    }
  })
  var calenderBtns = $('.slider_item_btn.avilable');

  function removeActive(targets) {
    $(targets).each((i, target) => {
      target.classList.remove('is_active');
    })
  }

  calenderBtns.on('click', (e) => {
    showHide();
    $('body').addClass('dummy');
    // console.log(e.target, e.currentTarget);
    removeActive(calenderBtns)
    $(e.currentTarget).addClass('is_active');
    $('.appointment_time').removeClass('is_active')
    $(".book_apointment_btn").addClass('disabled');
    filterTime(getDay());
    isToday(getDay());
    setTimeout(function() {
      $('body').removeClass('dummy');
      // console.log("transform");
      showHide('hide');
    }, 1250);
  });
  $(".book_apointment_btn").on('click', function(event) {
    event.preventDefault();
    $(drawerSecond).toggleClass('closed active')
    $(drawerThird).toggleClass('closed active');
    $("#appoinrment-date").val(
      getDay()
    );
  });

  $(".appointment_list li .avilable").on('click', function(event) {
    event.preventDefault();
    $(".book_apointment_btn").removeClass('disabled');
    $('.appointment_time').removeClass('is_active');

    $(this).addClass('is_active');

    $("#appoinrment-time").val($(this).text());

  });

  $('.drawer_slider').slick({
    dots: false,
    infinite: false,
    arrows: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1
  });
  $(".drawer_slider").slick('slickGoTo', 1, true);
  $('.mh-date-time').slick({
    dots: false,
    infinite: false,
    arrows: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
  });

  $("button.slider_btn.btn_prev.month-slider").click(function() {
    $('.drawer_slider').slick("slickPrev");
  });
  $("button.slider_btn.btn_next.month-slider").click(function() {
    $('.drawer_slider').slick("slickNext");
  });

  $("button.slider_btn.btn_prev.time-slider").click(function() {
    $('.mh-date-time').slick("slickPrev");
  });
  $("button.slider_btn.btn_next.time-slider").click(function() {
    $('.mh-date-time').slick("slickNext");
  });
  $('#signUp').click(function() {
    if ($(this).prop("checked") == true) {
      // console.log("Checkbox is checked.");
      localStorage.setItem("subscribe", true)
    } else if ($(this).prop("checked") == false) {
      // console.log("Checkbox is unchecked.");
      localStorage.setItem("subscribe", false)
    }
  });
  $(".mh-form").validate({
    rules: {
      "contact[nome]": {
        required: true,
        minlength: 2
      },
      "contact[cognome]": {
        required: true,
        minlength: 2
      },
      "contact[email]": {
        required: true,
        email: true
      }
    },
    messages: {
      name: {
        minlength: "Name should be at least 2 characters"
      },
      email: {
        email: "The email should be in the format: abc@domain.tld"
      }
    }
  });

  $(".mh-form .btn-submit").on('click', function(event) {
    event.preventDefault();
    localStorage.setItem("appointment", JSON.stringify($(".mh-form").serializeArray()))
    $(".mh-form").submit();
  });
})

/*engrave section*/
var fontsProperty = {
  'lowercase_normal': window.Shopify?.translations?.minuscolo,
  'lowercase_italic': window.Shopify?.translations?.["minuscolo corsivo"],
  'uppercase_normal': window.Shopify?.translations?.maiuscolo,
};
var colorsProperty = {
  '#000000': window.Shopify?.translations?.Nero,
  '#272a5d': window.Shopify?.translations?.Blue,
  '#37503A': window.Shopify?.translations?.["Verde Militare"],
  '#A81A20': window.Shopify?.translations?.Rosso,
  '#F18804': window.Shopify?.translations?.Arancio,
  '#FFFFFF': window.Shopify?.translations?.Bianco,
  '#cebaa1': window.Shopify?.translations?.Sabbia,
  '#d9d7d8': window.Shopify?.translations?.Grigio,
};
var defaultFont = "'Times New Roman Cyr'";
var defaultFont2 = "Times New Roman";
var defaultFontSize = "64px";
var defaultFontStyle = "normal";
var defaultFontCase = "lowercase";
var fontDidot = "Didot";
var fontAltastgreeting = "Altastgreeting";
var defaultColor = '#000000';

var selectedFont = defaultFont;
var selectedColor = defaultColor;
var selectedStyle = defaultFontStyle;
var selectedCase = defaultFontCase;
var engrave = {
  init: function() {
    this.close();
    $(".content-properties>div").on('click', function(event) {
      event.preventDefault();
      $(this).addClass('active').siblings('div').removeClass('active');
      var target = $(this).data('target');
      $(target).fadeIn('slow');
      $(target).siblings('.choice-overlay ').fadeOut('fast');
      $(".content-delete").fadeOut();
    });
  },
  unload: function() {
    $(".content-properties>div").off('click');
  },
  close: function() {
    $('.choice-overlay .icon').on('click', function(event) {
      event.preventDefault();
      $(".content-properties>div.active").removeClass('active');
      $(this).closest('.choice-overlay').fadeOut('fast');
      $(".content-delete").fadeIn();
    });
  }
};
function storeProperyData() {
  try {
    var storePropery = {
      font: `[data-style="${selectedStyle}"][data-case="${selectedCase}"]`,
      color: `[alt="${selectedColor}"]`,
      varian: $(".choose-item.active").data("vt"),
      initial: $("#input-type1").val(),
      key: sizePopup.selectedKey,
      size: sizePopup.selectedSize,
    };
    // console.log("inital: " + $("#input-type1").val());
    var localStorageData = JSON.stringify(storePropery);
    localStorage.setItem('property',localStorageData);
    $(".input-memory").val(localStorageData);
    $("#input-type1").data('memory',localStorageData);

    // console.log(JSON.parse(localStorage.getItem('property')));
  } catch (e) {
    console.log(e);
  }
}
function sizeDataKeys(localStorageData) {
  sizePopup.selectedKey = localStorageData.key;
  sizePopup.selectedSize = localStorageData.size;
}
function applyProperyData() {
  if(localStorage.getItem('property')){
    // console.log("this is called");

    var localStorageData = JSON.parse(localStorage.getItem('property'));
    // console.log(localStorageData);
    if (customerData.isLoggedIn) {
      sizeDataKeys(localStorageData);

    }

    if (!!localStorageData.initial) {
      $(localStorageData.font).click();

      $(`.choice-overlay-pattern ${localStorageData.color}`).click();
      $("#input-type1,.input-engrave").val(localStorageData.initial);
      $(".stay-right.write-engrave").html(localStorageData.initial);
      $("span.hidden.write-engrave").html(localStorageData.initial);
      $(".mobile-initial-placeholder").html(localStorageData.initial);
      base64($("#input-type1").val());

      tshirt();
    }
    setSize(localStorageData.size);

    $(localStorageData.varian).click();

    // localStorage.removeItem('property')
    return true;
  }
  return false;
}
function applyStyle(isCapitalized = false) {
  $("#input-type1,.engrave-text,.write-engrave,.mh-initial-text, .mh-inital-placeholder svg .st0,.mobile-initial-placeholder,#mobile-input").css({
    'font-family': selectedFont,
    'font-size': selectedFont,
    'text-transform': isCapitalized ? 'capitalize' : selectedCase,
    'font-style': selectedStyle,
    'color': selectedColor,
    'fill': selectedColor,
  });
    $("#input-type1").css({

      'text-transform': selectedCase,

    });
  if (selectedColor === "#FFFFFF") {
    $("#input-type1,.write-engrave,.mobile-initial-placeholder,#mobile-input").css({
      'color': "#B2B2B2",
      'fill': "#B2B2B2",
    });
  }

  base64($("#input-type1").val());
  // inital font and color
  $(".input-engrave-color").val(selectedColor)
  $(".input-engrave-font").val(`${defaultFont2} / ${selectedStyle} / ${selectedCase}`)
  // console.log(selectedFont, selectedColor, selectedStyle, selectedCase);
  var fontsPropertyCase = `${selectedCase}_${selectedStyle}`;
  $(".initial-font-type").val(
    fontsProperty[fontsPropertyCase]
  );
  $(".initial-font-color").val(
    colorsProperty[selectedColor]
  );
    // if(!localStorage.getItem('property')){
    //   storeProperyData();
    // }
    // console.log("applyStyle pages");
    storeProperyData();

}
$(function() {
  engrave.init();
  $('.choice-fonts > .item').on('click', function(event) {
    event.preventDefault();
    $(".font-choice .item img").attr('src', $(this).find("img").attr("src"));
    // selectedFont = $(this).data('font');
    selectedCase = $(this).data('case');
    selectedStyle = $(this).data('style');
    applyStyle();

    document.querySelector(".input-engrave").value = selectedCase === "uppercase" ? document.querySelector(".input-engrave").value.toUpperCase() : document.querySelector(".input-engrave").value.toLowerCase()
  });
  $('.choice-pattern img').on('click', function(event) {
    event.preventDefault();
    selectedColor = $(this).attr('alt');
    $("#imageColor").attr('src', $(this).attr('src'));
    applyStyle();
  });

  if ($("body").hasClass('template-product')) {
    // load default style
    var defaultCapticalize = true;
    if ($("#input-type1").val()) {
      defaultCapticalize = false;
      $(".write-engrave").html($("#input-type1").val())
    }
    // applyStyle(defaultCapticalize);

  }

  // delete button apply default style
  $(".content-delete .delete").on('click', function(event) {
    event.preventDefault();
    var fontSrc = $(".choice-overlay-font .choice-fonts span:first-child img").attr('src');
    var colorSrc = $(".choice-overlay-pattern .choice-pattern .item:first-child img").attr('src');
    $("#fontImage").attr('src', fontSrc);
    $("#imageColor").attr('src', colorSrc);

    // reset
    selectedFont = defaultFont;
    selectedColor = defaultColor;
    selectedStyle = defaultFontStyle;
    selectedCase = defaultFontCase;
    $("#input-type1,#mobile-input").val('');
    $(".input-engrave").val('No');

    applyStyle(true);

    $("#input-type1,#mobile-input").val('');
    $(".initial-font-type,.initial-font-color").val(null);
    $(".engrave-text").html(null);
    $('.write-engrave,.mobile-initial-placeholder').html('No');
  });
})


/*measurement modal*/
function resetPlayer() {
  try {
    $(".instruction-player-container").removeClass('player-mode');
    $(".instruction-player-container video")[0].pause();
    $(".instruction-player-container video")[0].currentTime = 0;
  } catch (e) {
    console.log("cannot pause");
  }
}
var appConfig = {
  init: function() {
    // console.log("initial load");
    $(".instruction-player-container:not(.player-mode)").on('click', function(event) {
      try {
        event.preventDefault();
        resetPlayer();
        // console.log("play video");
        var self = $(this);
        self.addClass('player-mode');
        self.find('video')[0].play();
      } catch (e) {
        console.log("video play: need to prevent this click event");
      }
    });
    $(".soat-modal .close-icon-wrapper .close-icon").on('click', function(event) {
      event.preventDefault();
      // console.log("close video");
      resetPlayer();
      app.close();
    });
    $(".v--modal-background-click").on('click', function(event) {
      event.preventDefault();
      // console.log("clicked " + event.target);
      if (event.target.className === 'v--modal-background-click') {
        // console.log('close the modal');
        resetPlayer();
        app.close();
      }
    });

  },
  unload: function() {
    $(".instruction-player-container:not(.player-mode)").off('click');
    $(".soat-modal .close-icon-wrapper .close-icon").off('click');
    $(".v--modal-background-click").off('click');
  }
};
var measurements = {
  in_to_cm: function(val) {
    var n = Number((val * 2.54).toFixed(1));
    var nstring = (n + ""),
      narray = nstring.split("."),
      result = "0." + (narray.length > 1 ? narray[1] : "0");

    // 0.5 or round to 1
    if (narray.length > 1) {
      n = +narray[1] > 5 ? Math.round(n) : +narray[0] + 0.5;

    }

    // console.log(n);
    return n;
  },
  cm_to_in: function(val) {
    var value = Number((val * 0.39370079).toFixed(1));

    // console.log(value);
    return value;
  }
}

var measurementStep = {
  cm: 0.5,
  inch: 0.2
}

function getFields(measurement) {
  for (const property in app.form) {
    app.form[property] = measurements[measurement](app.form[property])
  }

}
var defaultMeasurementsItem = measurementsItems[Object.keys(measurementsItems)[0]];
var formClass = ['size', 'size-chart', 'size-summary', 'login', 'thank-you', 'edit-size'];
var customerClass = ['login', 'register'];

/*validate email address*/
function validateEmail(email) {
  const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  return mailformat.test(email);
}
function toggleEmailError(value = false) {
  // add aria-label
  $("#RecoverEmail").attr('aria-invalid',value);
  $("#SubmitRecoverPasswordLink").attr("disabled",value)
}
function isEmailExist(email) {
  app['isEmail'] = true;
  app.emailError = emailError.unique;
  toggleEmailError(false);
}
function isEmailNotExist() {
  app['isEmail'] = false;
  app.emailError = emailError.error;
  toggleEmailError(true);
}
function uniqEmail(email) {
  // V2: Shopify sign-in handles new and existing emails
  if (useSizesV2()) {
    return;
  }

  $.ajax({
    type: 'POST',
    url: "http://themebuz.com/subscription/public/search",
    dataType: 'json',
    data: {
      email
    },
    success: function(res) {
      // console.log('customer get!');
      // console.log(res);
      // if emails exists, show error
      if(res.customers.length){
        // isEmailExist(res.customers)
      }else{
        isEmailNotExist();
      }
    },
    error: function(request, status, error) {
      // if it's not last one Move Along else update the cart number with the current quantity
      console.log(request.responseText);
      console.log("error");
    }
  });
}
/*db userId*/
function getUserID() {
  const result = `${customerData.first_name.replace("&#39;", "'")} ${customerData.last_name.replace("&#39;", "'")}(${customerData.id})`;
  return result
}
/*generate uuid*/
function uuid(date) {
  return date ? new Date(date).valueOf() : new Date().valueOf();
}
// toggle cart button
function toogleCartButton(value = false) {
  $(".product-form__cart-submit").prop('disabled',value);
}
/*set new size as selected*/
function setSize(name){
  // console.log(name);
  $(".properties-taglia").val(name);
}
// check new size exists in the localStorage
function checkNewSize() {
  if (!!localStorage.getItem("newSize")) {
    try {
      const personalizeBtn = document.querySelector(".save-continue-wrapper.fixed:not(.relative) .personalizza-btn")
      const shouldAutoOpen = !!localStorage.getItem("auto_open_product_form_register") || !!localStorage.getItem("auto_open_product_form_login")
      if (personalizeBtn && shouldAutoOpen) {
        personalizeBtn.click()
        localStorage.removeItem("auto_open_product_form_register")
        localStorage.removeItem("auto_open_product_form_login")
      }
    } catch (error) {
      console.error(error)
    }
    
    var newSize = JSON.parse(localStorage.getItem("newSize"));
      // console.log("size is added and select last created size");
    // console.log(newSize);
    newSize[Object.keys(newSize)[0]].cliente = {
      nome: customerData.name,
      email: customerData.email
    }
    saveAndUpdateSize(newSize)
    sizePopup.editSize = {
      ...sizePopup.editSize,
      ...newSize
    };
    app.editSize = {
      ...sizePopup.editSize
    };

    var localStorageData = {
        key: Object.keys(newSize)[0],
        size:   newSize[Object.keys(newSize)[0]]['nome taglia']
    };
    // console.log("store from save data");
    sizeDataKeys(localStorageData);
    setTimeout(storeProperyData,250);

    // removed the save size
    // V2: saveSizeV2() removes it once the write succeeds, because the write may redirect for a token
    if (!useSizesV2()) {
      localStorage.removeItem("newSize")
    }


  }
}
/*remove and update the doc*/
function removeAndUpdateSize(newSize, removedKey) {
  if (useSizesV2()) {
    removeSizeV2(removedKey);
    return;
  }

  // save if id not present
  // else update
  var ref = db.collection("Dati Taglie").doc(getUserID());
  ref.get({source: 'server'})
    .then(() => {
      // console.log(2, {newSize})

      // console.log("11111")
      ref.set(newSize);
      // console.log(newSize);
    })
    .catch((error) => {
      console.log(error);
    });
}
/*save the document*/
// key: the size to save when newSize holds several (V2 only; defaults to the first)
function saveAndUpdateSize(newSize, key) {
  // disableBtn
  toogleCartButton(true);

  if (useSizesV2()) {
    var sizeKey = key || Object.keys(newSize)[0];
    saveSizeV2(sizeKey, newSize[sizeKey]);
    return;
  }

  // save if id not present
  // else update
  
  var size = Object.values(newSize)[0];

  const date = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  };
  const formattedDate = date.toLocaleTimeString("it-IT", options);

  size._date = formattedDate;
  size.id = Object.keys(newSize)[0];

  var ref = db.collection("Dati Taglie").doc(getUserID());
  ref.get({source: 'server'})
    .then((thisDoc) => {
      // console.log("22222")
      if (thisDoc.exists) {
        try {
          const sizeKey = Object.keys(newSize)[0] 
          if (thisDoc.data()[sizeKey]) {
            Object.values(newSize)[0].updated = dayjs().locale('it').format('dddd DD MMMM, YYYY')
          }
        } catch (error) {
          console.error(error)
        }
        //user is already there, write only last login
        var data = {
          ...thisDoc.data(),
          ...newSize
        }
        ref.update(data);
        console.log(0, {newSize}) // Get 1st obj. value, 'nome taglia' field
        
      } else {
        // Send it
        ref.set(newSize);

        console.log(1, {newSize})
        // Custom code: fix
        // ref.update({updated: Date.now()});
      }

      // console.log(newSize);
      afterSizeSaved(Object.values(newSize)[0]);

    })
    .catch((error) => {
      toogleCartButton(false);

      console.log(error);
    });
}
// runs after a size is written (Firestore or metafield)
function afterSizeSaved(size) {
  try {
    klaviyo.track("Created Size", {
      "Product Handle": window.location.pathname.split("/").pop(),
      "Size Name": size['nome taglia'],
      'Product Title': document.querySelector("h1.product__title").innerText.replace(" | Filatori", ""),
      "Product URL": window.location.href,
      'Product Price': document.querySelector('[data-product-price]').innerText,
      'Product Image URL': "https://" + document.querySelector(".product__media .media__image img").src.replace("https://", "").replace(/$\/\//, "")
    });
    console.log("KL Create size event")
  } catch (error) {
    console.error(error)
  }

  // store the new size
  // storeProperyData();
  // apply the new size
  setSize(sizePopup.selectedSize);
  app.measurementActive = "cm";

  // enable it
  toogleCartButton(false);
}

/*
 * V2 size storage (Stage 4 of docs/V1_TO_V2_MIGRATION.md).
 * Sizes live in the customer metafield filatori_v2.sizes (assets/filatori-sizes.js).
 * The Vue UI keeps working with V1 objects keyed by timestamp; they're converted here.
 * On when theme.liquid loads window.FilatoriSizes (setting customer_accounts_v2).
 */
function useSizesV2() {
  return Boolean(window.FilatoriSizes);
}

// V2 sizes array → V1 object keyed by timestamp, as used by the Vue UI
function sizesToV1(sizes) {
  var result = {};
  sizes.forEach(function addSize(size) {
    result[size.timestamp] = {
      'nome taglia': size.title,
      'taglia ready to wear': size.size,
      'altezza': size.height,
      fit: size.fit,
      dati: size.measurements,
      'type': size.originProductType
    };
  });

  return result;
}

// V1 size → V2 size. createdAt and updatedAt are set by FilatoriSizes.saveSize()
function sizeToV2(key, size) {
  return {
    timestamp: String(key),
    type: 'custom',
    title: size['nome taglia'] ?? null,
    size: size['taglia ready to wear'] ?? null,
    height: size['altezza'] ?? null,
    fit: size.fit ?? null,
    measurements: size.dati || {},
    originProductType: size['type'] ?? null
  };
}

// retryUnsaved: false after a failed write, so a kept newSize isn't retried in a loop
async function fetchSizesV2(vm, retryUnsaved = true) {
  var sizes = await window.FilatoriSizes.getSizes();
  var editSize = sizesToV1(sizes || []);

  // Retry a removal that was interrupted by a token redirect
  var removedKey = localStorage.getItem("removedSize");
  if (sizes && removedKey && retryUnsaved) {
    delete editSize[removedKey];
    removeSizeV2(removedKey);
  }

  sizePopup.editSize = app.editSize = editSize;
  if (!Object.keys(editSize).length) {
    vm.isEditSize = false;
  }

  // Logged out: keep newSize for after sign-in
  if (sizes && retryUnsaved) {
    // The Liquid read resolves before DOM ready, where applyProperyData() would reset
    // the selected size to the one stored before sign-in. Run after it.
    $(function checkNewSizeWhenReady() {
      checkNewSize();
      sortSizeData();
    });
  } else {
    sortSizeData();
  }
}

// Errors a retry can't fix. Any other failure (network, token, stale) keeps newSize for the next page load.
var permanentSizeErrors = ['invalid_shape', 'too_large', 'user_errors'];

async function saveSizeV2(key, size) {
  // The write may redirect for a token. After the reload, checkNewSize() saves it again.
  var pending = {};
  pending[key] = size;
  localStorage.setItem("newSize", JSON.stringify(pending));

  try {
    await window.FilatoriSizes.saveSize(sizeToV2(key, size));
  } catch (error) {
    if (permanentSizeErrors.includes(error.code)) {
      localStorage.removeItem("newSize");
    }
    onSizeWriteError(error);
    return;
  }

  localStorage.removeItem("newSize");
  afterSizeSaved(size);
}

async function removeSizeV2(key) {
  // The write may redirect for a token. After the reload, fetchSizesV2() removes it again.
  localStorage.setItem("removedSize", String(key));

  try {
    await window.FilatoriSizes.removeSize(String(key));
  } catch (error) {
    localStorage.removeItem("removedSize");
    onSizeWriteError(error);
    return;
  }

  localStorage.removeItem("removedSize");
}

// Show the error and reload the sizes, so the UI matches what is stored
function onSizeWriteError(error) {
  console.error(error);
  toogleCartButton(false);
  toastr.error(window.Shopify?.translations?.size_save_failed);
  fetchSizesV2(sizePopup, false).catch((fetchError) => {
    console.log(fetchError);
  });
}

/*
 * V2 sign-in and profile (Stage 5 of docs/V1_TO_V2_MIGRATION.md).
 * Replaces the login and register panels and the drawer login with the storefront sign-in.
 * Shopify sign-in only collects an email, so name and newsletter consent are asked
 * afterwards (complete-profile step, assets/filatori-profile.js).
 */

// withSize: the size designed in the modal is kept in newSize and saved after the redirect back
// returnTo: the page to land on after sign-in (default: the current page)
function signInV2(withSize, returnTo) {
  if (withSize) {
    app.submitData();
    localStorage.setItem("auto_open_product_form_login", true);
  }
  storeLoggedIn();
  localStorage.setItem("askNameAfterSignIn", true);
  window.FilatoriAuth.signIn(returnTo);
}

// After a sign-in started here: ask a customer without a name to complete their profile
function completeProfileV2() {
  if (!useSizesV2() || !customerData.isLoggedIn) {
    return;
  }

  // Retry a profile save that was interrupted by a token redirect
  var unsavedProfile = localStorage.getItem("unsavedProfile");
  if (unsavedProfile) {
    saveNameAndNewsletter(JSON.parse(unsavedProfile));
    return;
  }

  if (!localStorage.getItem("askNameAfterSignIn")) {
    return;
  }

  localStorage.removeItem("askNameAfterSignIn");
  if (customerData.first_name) {
    return;
  }

  app.activeForm = 'complete-profile';
  app.open();
}
setTimeout(completeProfileV2, 1500);

async function saveNameAndNewsletter(profile) {
  // The write may redirect for a token. After the reload, completeProfileV2() saves it again.
  localStorage.setItem("unsavedProfile", JSON.stringify(profile));
  app.profileSaving = true;

  try {
    await window.FilatoriProfile.updateName(profile.firstName, profile.lastName);
    if (profile.subscribe) {
      await window.FilatoriProfile.subscribeToNewsletter();
    }
  } catch (error) {
    console.error(error);
    localStorage.removeItem("unsavedProfile");
    app.profileSaving = false;
    toastr.error(window.Shopify?.translations?.profile_save_failed);
    return;
  }

  localStorage.removeItem("unsavedProfile");
  app.profileSaving = false;

  customerData.first_name = profile.firstName;
  customerData.last_name = profile.lastName;
  customerData.name = profile.firstName + ' ' + profile.lastName;

  app.activeForm = 'welcome';
  app.open();
  setTimeout(greencheckAnimation, 50);
  // auto close
  setTimeout(app.close, 5000);
}
/*sort size data*/
function sortSizeData() {
  // sort the data
  var sizeDataKeys = []
  for (const [key] of Object.entries(sizePopup.editSize)) {
    // console.log(key)
    sizeDataKeys.push(key)
  };
  sizeDataKeys.sort(function(a, b) {
    return b - a;
  });
  var newSizeData = {}
  sizeDataKeys.forEach((key, i) => {
    newSizeData[key] = {
      ...sizePopup.editSize[key]
    }
  });
  app.editSize = sizePopup.editSize = mobileSizePopup.editSize = {
    ...newSizeData
  };
}

/*body profile*/

var bodyProfile = {
  upper: "upper body",
  lower: "lower body"
};

/*this is first vue apps*/
var app, sizePopup, mobileSizePopup,adminApp,selectedCustomer,customerSizeData;
/*this is second vue apps*/
var sizeContainerData = {
  isLoggedIn: customerData.isLoggedIn,
  showSizePopup: false,
  selectedSize: window.Shopify?.translations?.Usa_taglia_salvata,
  selectedKey: null,
  editSize: editSize,
  productType: productType || defualtProductType,
  isEditSize: true
};
var emailError = {
  error: 'Campo obbligatorio',
  unique: window.Shopify?.translations?.Mail_usata,
  // unique: '<span>Indirizzo e-mail già in uso. <span style="text-decoration:underline;" href="/account/login" @click="window.open(\'/account/login\')">Registrati.</span><span>',
  // unique: '<span>Indirizzo e-mail già in uso. <span style="text-decoration:underline;cursor:pointer;" onclick="window.open(\'/account/login\')">Registrati.</span></span>',
};
Vue.use(VeeValidate)
app = new Vue({
  el: "#mh-body-modal",

  delimiters: ["${", "}"],
  data: {
    show: false,
    config: true,
    isSized: false,
    redirect: true,
    // Stage 5: storefront sign-in instead of the login and register panels
    showStorefrontSignIn: useSizesV2(),
    profileSaving: false,
    welcome: false,
    customerData: customerData,
    registerHeader: window.Shopify?.translations?.Salva_la_tua_taglia,
    input: 'mh-number',
    activeForm: 'size',
    profile: bodyProfile.upper,
    form: {
      ...selectSize.s,
      ...selectOptionalSize.s
    },
    // form2: {
    //   ...selectSize.s
    // },
    formFields: Object.keys(measurementsItems),
    optionalFormFields: Object.keys(optionalMeasurementsItems),
    showAdvacneOption: false,
    customer: 'login',
    measurementsData: [],
    measurementActive: 'cm',
    selectedSize: 's',
    selectedHeight: "175",
    sizeName: `${sizeContainerData.productType} - ${dayjs().format('DD/MM/YY')}`,
    activeName: Object.keys(measurementsItems)[0],
    showDescription: false,
    video: defaultMeasurementsItem.video,
    image: defaultMeasurementsItem.img,
    title: defaultMeasurementsItem.title,
    text: defaultMeasurementsItem.text,
    productType: sizeContainerData.productType,
    productVendor: productVendor,
    defaultVariant: defaultVariant,
    activeItem: 'slim-fit',
    disableBtn: true,
    loading: '',
    email: '',
    isEmail: false,
    emailError: emailError.error,
    password: '',
    isPassword: false,
    firstName: '',
    isfirstName: false,
    lastName: '',
    isLastName: false,
    phone: '',
    subscribe: false,
    sizeSummary: [],
    isLoggedIn: customerData.isLoggedIn,
    showSizePopup: false,
    editSize: editSize,
    editSizeName: '',
    removeSizeName: '',
    editSizeKey: '',
    removeAddress: null,
  },
  computed: {
    activeClass: function() {
      return app.activeForm !== 'size' ? `show-login-details mh-${app.activeForm}` : `mh-${app.activeForm}`;
    },

  },
  watch: {
    selectedSize: function(val, oldVal) {
      app.measurementActive = 'cm';
      app.updateSizeDetails(val);
    },
    customer: function(val) {
      // console.log(val);
      this.email = "";
      this.password = "";
      this.firstName = "";
      this.lastName = "";

      this.isEmail = false;
      this.isPassword = false;
      this.isfirstName = false;
      this.isLastName = false;

    },
    email(val) {
      this.debounceInput(val);
      this.checkField('isEmail', val);
    },
    password(val) {
      this.checkField('isPassword', val);

    },
    firstName(val) {
      this.checkField('isfirstName', val);

    },
    lastName(val) {
      this.checkField('isLastName', val);
    },
    subscribe(val){
      // console.log(val);

    }
  },
  methods: {
    debounceInput: _.debounce(function (e) {
       // console.log(this.email);
       const isEmail = validateEmail(this.email);
       if(isEmail) {
         uniqEmail(this.email);
       }
     }, 300),
    open: function() {
      this.show = true;
      $("body").addClass('modal-show');
      if(app.config){
      }
      setTimeout(appConfig.init, 800);

    },
    close: function() {
      
      this.show = false;
      this.isSized = false;
      this.customer = 'login';
      this.welcome = false;
      this.registerHeader = "Salva la tua taglia";
      this.form = {
        ...selectSize[app.selectedSize],
        ...selectOptionalSize[app.selectedSize]
      }
      $("body").removeClass('modal-show');
      if(app.config){

      }
      appConfig.unload();
      //back to size form
      app.activeForm = 'size';

      try {
        window.scrollTo(0, $(".fixed-scroll").offset().top - 70);
      } catch (error) {
        console.error(error)
      }

      // window.scrollTo(0, document.querySelector(".product__media").lastElementChild.offsetTop + 75)
      // setTimeout(() => window.scrollTo(0, 999999999999), 100)

    },
    play: function() {

    },
    // Validator function
    checkField(filed, val) {
      if (!!(val && val.trim())) {
        app[filed] = false;
      } else {
        app[filed] = true;
      }
    },
    isRequired(value) {
      if (!value) {
        return 'this field is required';
      }

      return true;
    },
    submitData() {
      // save the size
      var key = uuid();
      var newSize = {};
      // if measurement is inch, convert cm
      if (app.measurementActive == 'inch') {
        getFields('in_to_cm');
        app.measurementActive = 'cm';
      }
      newSize[key] = {
        'nome taglia': app.sizeName,
        'creato il': dayjs(key).locale('it').format('dddd DD MMMM, YYYY'),
        cliente: {
          nome:app.firstName + ' ' + app.lastName,
          email: app.email
        },
        'taglia ready to wear': app.selectedSize,
        'altezza': app.selectedHeight,
        fit: app.activeItem.split('-')[0],
        dati: app.form,
        'body profile': app.profile,
        'type': app.productType
      };
      // console.log(newSize);
      // store the localStorage
      localStorage.setItem("newSize", JSON.stringify(newSize));
    },
    submit(type = 'login') {
      this.$validator.validateAll().then(isValid => {
        // console.log(isValid);
        if (!this.errors.any()) {
          // console.log('submit')
          if (type == 'login') {
            this.login();
          } else {
            this.register();
          }
        }
      }).catch(e => console.log(e));

    },
    login() {

      this.submitData();

      localStorage.setItem("auto_open_product_form_login", true);

        const form = document.querySelector(".size-creator-panel #customer_login");
       
        const formData = new FormData(form);
        const searchParams = new URLSearchParams();
      
        for (const pair of formData) {
          searchParams.append(pair[0], pair[1]);
        }

        fetch(form.action, {
          method: form.method,
          body: searchParams,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          // redirect: 'manual'
        }).then(res => {
          // console.log(res.status, res.url)
          const failed = res.url.includes("/account/login")
          if (failed) {
            const span = document.createElement("div")
            span.style.order = "2"
            span.classList.add("errors")
            span.classList.add("errors-custom")
            span.innerHTML = window.Shopify.translations.wrong_email_password
            form.querySelector("[type=password]").before(span)
          } else {
            window.location.reload()
          }
        })
      

      // submit
      
      
      // $(".size-creator-panel #customer_login").submit();
    },
    registerData() {
      var data = {
          "name": app.firstName,
          "last_name": app.lastName,
          "email" : app.email,
          "phone" : app.phone,
          // 'password' : app.password || null,
          'subscribe': app.subscribe
      };
      // console.log(data);
      $.ajax({
        type: 'POST',
        url: "http://themebuz.com/subscription/public/customer/create",
        dataType: 'json',
        data: data,
        success: function(res) {
          // console.log('new customer added! ');
          // console.log(res);
          customerData = res.customer;

          customerData.name = customerData.first_name + ' ' + customerData.last_name;

          customerData.isLoggedIn =
          app.isLoggedIn = sizePopup.isLoggedIn =
          mobileSizePopup.isLoggedIn = true;

          app.customerData = customerData;

          if (app.isSized) {
            checkNewSize();
          }
          adminApp.customers.unshift(res.customer);
          adminApp.setCustomer(res.customer);

          app.activeForm = 'welcome';
          app.welcome = true;
          setTimeout(greencheckAnimation,50);
          // auto close
          setTimeout(app.close,5000);
        },
        error: function(request, status, error) {
          // if it's not last one Move Along else update the cart number with the current quantity
          // console.log(request.responseText);
          console.log("error");
          $.ajax({
            type: 'POST',
            url: "http://themebuz.com/subscription/public/customer/create",
            dataType: 'json',
            data: data,
            success: function(res) {
              // console.log('new customer added! ');
              // console.log(res);
              customerData = res.customer;

              customerData.name = customerData.first_name + ' ' + customerData.last_name;

              customerData.isLoggedIn =
              app.isLoggedIn = sizePopup.isLoggedIn =
              mobileSizePopup.isLoggedIn = true;

              app.customerData = customerData;

              if (app.isSized) {
                checkNewSize();
              }
              adminApp.customers.unshift(res.customer);
              adminApp.setCustomer(res.customer);

              app.activeForm = 'welcome';
              app.welcome = true;
              setTimeout(greencheckAnimation,50);
              // auto close
              setTimeout(app.close,5000);
            },
            error: function(request, status, error) {
              // if it's not last one Move Along else update the cart number with the current quantity
              // console.log(request.responseText);
              console.log("error 2");
            }
          });
        }
      });
    },
    clearErr() {
      document.querySelector(".errors-custom").innerText = ""
    },
    signIn() {
      signInV2(this.isSized);
    },
    onProfileFormSave() {
      this.checkField('isfirstName', this.firstName);
      this.checkField('isLastName', this.lastName);
      if (this.isfirstName || this.isLastName) {
        return;
      }

      saveNameAndNewsletter({
        firstName: this.firstName.trim(),
        lastName: this.lastName.trim(),
        subscribe: this.subscribe
      });
    },
    register(url) {
      this.checkField('isEmail', this.email);
      this.checkField('isPassword', this.password);
      this.checkField('isfirstName', this.firstName);
      this.checkField('isLastName', this.lastName);
      if (!this.isEmail && !this.isPassword && !this.isfirstName && !this.isLastName) {
        // console.log("do register: " + url);
        storeLoggedIn();
        if (app.isSized) {
          this.submitData();
        }
        if (app.redirect) {
          localStorage.setItem("registerSubscribe",this.subscribe);
          localStorage.setItem("showWelcome",true);

          if (url && app.isSized) {
            localStorage.setItem("auto_open_product_form_register", true);
            localStorage.setItem("product_url", url);
          } else if (url) {
            localStorage.removeItem("newSize");
            localStorage.setItem("product_url", url);
          } else {
            localStorage.removeItem("newSize");
            localStorage.removeItem("product_url", url);
          }
          setTimeout(function () {
              const form = document.querySelector("#create_customer");
             
              const formData = new FormData(form);
              const searchParams = new URLSearchParams();
            
              for (const pair of formData) {
                searchParams.append(pair[0], pair[1]);
              }
      
              fetch(form.action, {
                method: form.method,
                body: searchParams,
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                },
                // redirect: 'manual'
              }).then(res => {
                // console.log(res.status, res.url)
                const failed = res.url.includes("/account/register")
                if (failed) {
                  const span = document.createElement("div")
                  span.style.order = "2"
                  span.classList.add("errors")
                  span.classList.add("errors-custom")
                  span.innerHTML = window.Shopify.translations.register_failed
                  form.querySelector("[type=password]").before(span)
                } else {
                  window.location.reload()
                }
              })

            
          },100);
        } else {
          this.registerData();
        }

      } else {
        console.error(`Was not able to validate email, pwd, first and last name.`);
      }
    },
    toogleDescription() {
      app.showDescription = !app.showDescription;
    },
    back() {
      var prev = formClass.indexOf(app.activeForm) - 1;
      if (prev > -1) {
        resetPlayer();
        app.activeForm = formClass[prev]
      }
    },
    getMeasurementText(name) {
      // console.log("GMT", name)
      return {...window.measurementsItems, ...window.optionalMeasurementsItems}[name].title
    },
    changeCase(name) {
      // console.log("CC", name)
      return name.replace('_', ' ');
    },
    updateDetails: function(name) {
      // console.log(name);
      if (this.activeName !== name) {
        var details = {...measurementsItems, ...optionalMeasurementsItems}[name];

        this.image = details.img;
        resetPlayer();
        this.activeName = name;
        this.video = details.video;
        this.title = details.title;
        this.text = details.text;
      }
    },
    measurementToggle: function(active = 'cm') {
      this.measurementActive = active === 'cm' ? 'inch' : 'cm';
      var measurement = active === 'cm' ? 'cm_to_in' : 'in_to_cm';
      getFields(measurement);
    },
    measurement: function(measurement, active = 'cm') {
      this.measurementActive = active;
      getFields(measurement);
    },
    increase: function(name) {
      if (this.activeName !== name) {
        this.updateDetails(name);
      }
      let v = app.form[name]
      if (typeof v === "string" && v.includes(",")) v = v.replace(",", ".")
      var value = (Number(v || 0) + Number(measurementStep[app.measurementActive] || 1 )).toFixed(1);
      app.form[name] = Number(value)
    },
    decrease: function(name) {

      if (this.activeName !== name) {
        this.updateDetails(name);
      }
     let v = app.form[name]
      if (typeof v === "string" && v.includes(",")) v = v.replace(",", ".")
      var value = (Number(v || 0) - Number(measurementStep[app.measurementActive] || 1)).toFixed(1);

      app.form[name] = Number(value)


    },
    removeSize(){
      customerSizeData.remove();
    },
    doRemoveAddress(){
      // console.log("which form? " + this.removeAddress);
      $(this.removeAddress).submit();
      this.removeAddress = null
    },
    resetSize(key = null) {
      // always reset to cm
      // console.log(key);
      app.measurementActive = 'cm';
      if (key) {
        app.form = {
          ...app.editSize[key].dati
        }
      } else {
        app.updateSizeDetails(app.selectedSize);
      }
    },
    setSize: function() {
      this.sizeName = `${app.productType} - ${app.activeItem.split('-')[0]} - ${dayjs().format('DD/MM/YY')}`;
    },
    sizeInput(activeSize) {
      $("input.mh-number").map((idx, el) => {
        var name = $(el).attr('name');
        var target = $(`[name="${$(el).attr('name')}"]`)
        // console.log(activeSize[name]);
        $(target).val(activeSize[name])
      });
    },
    updateSizeDetails: function(val) {
      var activeSize = {...selectSize, ...selectOptionalSize}[val];
      // app.sizeInput(activeSize);
      app.form = {
        ...selectSize[val],
        ...selectOptionalSize[val],
      }
    },
    save: function() {
      app.setSize();
      app.measurementsData = [];
      $(".range-container input.number").map(function(index, elem) {
        app.measurementsData.push($(elem).val());
      });
      store.set('measurementsData', JSON.stringify(app.measurementsData));
      this.activeForm = 'login';
    },
    isActive(menuItem) {
      return this.activeItem === menuItem
    },
    setActive(menuItem) {
      this.activeItem = menuItem
    },
    modifySize() {
      app.inputs(activeSize);
    },
    saveNewSize() {
      var key = uuid();
      var newSize = {};
      // if measurement is inch, convert cm
      if (app.measurementActive == 'inch') {
        getFields('in_to_cm');
      }
      newSize[key] = {
        'nome taglia': app.sizeName,
        'creato il': dayjs(key).locale('it').format('dddd DD MMMM, YYYY'),
        cliente: {
          nome: customerData.name,
          email: customerData.email
        },
        'taglia ready to wear': app.selectedSize,
        'altezza': app.selectedHeight,
        fit: app.activeItem.split('-')[0],
        dati: app.form,
        'body profile': app.profile,
        'type': app.productType
      };
      app.close();
      saveAndUpdateSize(newSize)
      sizePopup.editSize = {
        ...sizePopup.editSize,
        ...newSize
      };
      app.editSize = {
        ...sizePopup.editSize
      };

      // Custom code: fix
      if (!customerSizeData) {
        customerSizeData = {}
      }

      customerSizeData.editSize = {
        ...sizePopup.editSize,
        ...newSize
      };
      customerSizeData.isEditSize = true;
      sortSizeData()
      sizePopup.selectedKey = key;
      sizePopup.selectedSize =   newSize[key]['nome taglia']

     
    },
    toggleAdvOpt() {
      app.showAdvacneOption = !app.showAdvacneOption
      setTimeout(() => {
        const el = document.querySelector('.additional-fields .show-contents')
        el.scrollIntoView({ behavior: "smooth", block: "end"  })
        
      }
        
        , 100  )

    },
    saveEditSizeWithName() {
      app.sizeName = "";
      app.activeForm = "login";
    },
    saveEditSize() {
      // if measurement is inch, convert cm
      if (app.measurementActive == 'inch') {
        getFields('in_to_cm');
      }
      app.editSize[sizePopup.selectedKey].dati = {
        ...app.form
      }
      app.close();
      // console.log("AA2")
      saveAndUpdateSize(app.editSize, sizePopup.selectedKey)
      // console.log(sizePopup);
      sizePopup.editSize = {
        ...app.editSize
      };
      sortSizeData()

    },
    showSizeChart: function() {
      app.sizeSummary = [];
      $("input.mh-number").map((idx, el) => {
        // console.log($(el).attr('name') + ": " + $(el).val());
        app.sizeSummary.push(
          $(el).attr('name') + ": " + $(el).val() + " " + app.measurementActive
        );
      });
      app.activeForm = 'size-chart'
    },
    thankyou: function() {
      app.activeForm = 'thank-you';
      app.loading = 'loader-line-animated';
      var ct;
      clearTimeout(ct);
      ct = setTimeout(function() {
        app.activeForm = 'size-summary';
        app.loading = '';
        app.isSized = true;
      }, 2000);
    }
  },
  created() {
    // fetchInstagram();
  },
});

function loginFrom() {
  // V2: storefront sign-in instead of the drawer login
  if (useSizesV2()) {
    signInV2(false);
    return;
  }

  $(".login_drawer").toggleClass('is_open');
  $("body").toggleClass('is_body_open');
}

$(".login_drawer .drawer_close_btn").on("click", function(){
  loginFrom();
});

var sizeContainer = {
  data:{
    ...sizeContainerData
  },
  computed: {
    editSizeName() {
      var name = [];
      for (const [key, value] of Object.entries(editSize)) {
        name.push(key)
      }
      return name;
    }
  },
  watch:{
    selectedKey(){

    },
    editSize(){
      if (!Object.keys(customerSizeData.editSize).length) {
        this.isEditSize = false;
      }
    }
  },
  methods: {
    remove(key){
      // console.log(key, size);
      var removedKey = customerSizeData.key;
      Vue.delete(customerSizeData.editSize,customerSizeData.key);
      removeAndUpdateSize(customerSizeData.editSize, removedKey);
      app.close();
    },
    loginFrom(){
      loginFrom();
    },
    togglePopup() {
      this.showSizePopup = !this.showSizePopup;
    },
    selectTheSizeName(key) {
      // console.log(index,this.editSizeName[index]);
      this.selectedKey = key;
      this.selectedSize = this.editSize[key]['nome taglia'];
      this.togglePopup();
      $(".input-size").val(this.selectedSize);

      // console.log("selectTheSizeName");
      storeProperyData();
    },
    open() {
      app.open();

    },
    close() {

    },
    createSize() {
      this.togglePopup();
      app.open();
    },
    editPopup() {
      app.activeForm = "edit-size";
      app.editSizeName = this.selectedSize;
      app.editSizeKey = this.selectedKey;
      app.form = {
        ...this.editSize[this.selectedKey].dati
      };
      // storeProperyData();
      app.open();
    },
    fetchDB() {
      if (useSizesV2()) {
        fetchSizesV2(this).catch((error) => {
          console.log(error);
        });
        return;
      }

      var ref = db.collection("Dati Taglie").doc(getUserID());
      ref.get({source: 'server'})
        .then((thisDoc) => {
          // console.log("33333")
          
          if (thisDoc.exists) {
            //user is already there, write only save data
            sizePopup.editSize = app.editSize = {
              ...thisDoc.data()
            }

          } else {
            sizePopup.editSize = app.editSize = {}
            this.isEditSize = false;
          }
          // console.log("vue data updated")
        })
        .then(function() {
          checkNewSize();
        })
        .then(function() {
          sortSizeData();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
}
sizePopup = new Vue({
  el: "#second-vue-app",
  delimiters: ["${", "}"],
  data: sizeContainer.data,
  computed: sizeContainer.computed,
  methods: sizeContainer.methods,
  watch: {
    selectedSize: function(a,b) {
      try {
        // console.log({a,b})
        if (a) {
          document.querySelector("#mobile-size-btn").innerText = a
          const mobileBar = document.querySelector("#menuSelectBarMobile")
          if (mobileBar) {
            mobileBar.dataset.hasSelectedSize = true
          }
        }
      } catch (error) {
        console.error(error)
      }
    }
  },
  created() {
    // console.log("sizeContainer moved");
    // V2: a new customer has no name until the complete-profile step, but has sizes to load and save
    if (useSizesV2() && customerData.isLoggedIn) {
      this.fetchDB();
    } else if (customerData && customerData.name) {
      this.fetchDB();
    }
  }
});
mobileSizePopup = new Vue({
  el: "#mobile-vue-app",
  delimiters: ["${", "}"],
  data: sizeContainer.data,
  computed: sizeContainer.computed,
  methods: sizeContainer.methods,
  created() {
    // console.log("mobileSizePopup open");
    // if (customerData && customerData.name) {
    //   this.fetchDB();
    // }
  }
});
$(function() {

  $(".create-size.size-btn-contaier .create-size-btn").on('click', function(event) {
    event.preventDefault();
    app.open();
  });

  $(".product-from-cart-btn").on('click', function(event) {
    event.preventDefault();
    toastr.options = {
      "closeButton": false,
      "debug": false,
      "newestOnTop": false,
      "progressBar": false,
      "positionClass": "toast-top-left",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "4000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    }
    if (!sizePopup.selectedKey) {
      toastr.info('', window.Shopify?.translations?.create_size_to_add_to_cart, {
        iconClass: "toast-custom"
      })
    } else {
      $(".product-from-cart-btn").siblings("button").click()
    }
  });

  // $("a.media__image").on('click', function(event) {
  //   event.preventDefault();
  //   /* Act on the event */
  //   var open = $(this).data("open");
  //   console.log(open);
  // });
  $('.media-modal').magnificPopup({
    type: 'image',
    preloader: false,
    fixedContentPos: true,
    callbacks: {
      imageLoadComplete: function() {
        if (window.innerWidth < 960) {
          const fig = this.currItem.img[0].parentElement
          fig.scrollTo((fig.scrollWidth - fig.offsetWidth) / 2, 0)
        }
      },
    }
    // other options
  });

})

$(function () {
  // product mobile
  // setTimeout(function () {
  //   $("div#shopify-section-product-recommendations--static").hide();
  // },300);
  enquire.register("screen and (max-width:959px)", {
// OPTIONAL
// If supplied, triggered when a media query matches.
match: function () {
  $("div#shopify-section-footer,div#shopify-section-text--static,div#shopify-section-gallery-grid--static,div#shopify-section-product-recommendations--static").hide();
    $(".mh_product-template,.header-container").show();
imageSlider.reinit();

  // console.log("match for mobile");
},

// OPTIONAL
// If supplied, triggered when the media query transitions
// *from a matched state to an unmatched state*.
unmatch: function () {
  if ($("body").hasClass("top")) {
      // $(".product-name-price,.save-continue-wrapper.fixed .close-btn").trigger("click");
      $("body").removeClass('top');

  }
  // self.slider();
  // console.log("match for true");
},

// OPTIONAL
// If supplied, triggered once, when the handler is registered.
setup: function () {
  // console.log("setup for related items");
},

// OPTIONAL, defaults to false
// If set to true, defers execution of the setup function
// until the first time the media query is matched
deferSetup: true,

// OPTIONAL
// If supplied, triggered when handler is unregistered.
// Place cleanup code here
destroy: function () {},
});
  $(".product-name-price,.save-continue-wrapper.fixed .close-btn").on('click', function(event) {
    event.preventDefault();
    document.querySelector(".header-container").style.opacity = 0
    document.querySelector(".mh_product-template").style.opacity = 0
    document.querySelector(".mh_product-template").style.transition = "opacity 200ms linear"
    if (!window.prevScrollTop) {
      window.prevScrollTop = window.pageYOffset
    } 

    $("div#shopify-section-footer,div#shopify-section-text--static,div#shopify-section-gallery-grid--static,div#shopify-section-product-recommendations--static,.mh_product-template,.header-container").toggle();

    $("html, body").scrollTop($('body').offset().top);
    $("body").toggleClass('top');
    
    setTimeout(() => {
      if (window.prevScrollTop && document.querySelector(".mh_product-template").style.display !== 'none') {
        window.scrollBy(0, window.prevScrollTop)
        window.prevScrollTop = 0
      }

      let h = $(".mobile-variants-options-wrapper").outerHeight(true) * 0.01 * 100;
      document.documentElement.style.setProperty('--variants', `-${h}px`);
    }, 10)
    
    setTimeout(() => {
      document.querySelector(".mh_product-template").style.opacity = 1
      document.querySelector(".header-container").style.opacity = 1
      
    }, 200)

    try {
      imageSlider.reinit()
      var variant = Shopify.theme.product.getVariantFromOptionArray(mhProductJSON, getSelectedVariant())
      var imgId = variant.featured_media.id;
      var idx = $(`[data-media-id='${imgId}']`).data('slick-index');
      $(productSlider).slick('slickGoTo',idx)
    } catch (error) {
      console.error(error)
    }
  });
  // open
  $(".save-continue-wrapper.fixed:not(.relative) .personalizza-btn").on('click', function(e) {
    // getVariantHeight();
    setTimeout(getVariantHeight,50);
    $(this).toggle().siblings('.personalizza').toggle();
    setTimeout(function () {
      $(".mobile-variants-options-wrapper").removeClass('effect');
    },250);
  })
  // hide text and toggle buttons
  $(".save-continue-wrapper.relative .personalizza-btn").on('click', function(e) {
    document.querySelector(".mh_product-template").style.opacity = 0
    
    $("div#shopify-section-footer,div#shopify-section-text--static,div#shopify-section-gallery-grid--static,div#shopify-section-product-recommendations--static,.mh_product-template,.header-container").slideToggle(400);
    $("body").toggleClass('top');
    $(".save-continue-wrapper.fixed:not(.relative) .personalizza-btn").hide().siblings('.personalizza').show();
    setTimeout(getVariantHeight,50);
    
    setTimeout(function () {
      $(".mobile-variants-options-wrapper").removeClass('effect');
      tshirt();
    },250);
    setTimeout(function () {
      document.querySelector(".mh_product-template").style.opacity = 1
    },250+300);

    // Somehow there are two of these buttons, with no way to tell the difference
    try {
      const bothBtns = document.querySelectorAll(".personalizza-btn")
      const isSecondBtn = bothBtns[1] === e.currentTarget
      if (isSecondBtn) {
        imageSlider.reinit()
        var variant = Shopify.theme.product.getVariantFromOptionArray(mhProductJSON, getSelectedVariant())
        var imgId = variant.featured_media.id;
        var idx = $(`[data-media-id='${imgId}']`).data('slick-index');
        $(productSlider).slick('slickGoTo',idx)
      }
    } catch (error) {
      console.error(error)
    }

  })
  // add to cart
  $(".cell.add-to-cart").on("click", function(e) {
    $(".product-form__cart-submit.product-from-cart-btn ").click();
  });
  // toogle Hide title
  function hideTitle() {
    if(  $(".js-panel-opener-color").hasClass("on") || $(".js-panel-opener-size").hasClass("on")){
      $(".product-name-price").hide();
    }else{
      $(".product-name-price").show();
    }
  }
  // mobile size
  $(".js-panel-opener-size").on("click", function(e){
    event.preventDefault();
    $(".js-panel-opener-color").removeClass("on");
    $("#mobile-color-app").hide();
    $(this).toggleClass('on');
    hideTitle();
    $("#mobile-vue-app").toggle();
  });

  // mobile color
  // $(".js-panel-opener-color img")
  //   .attr("src",defaultSrc)
  $(".js-panel-opener-color").on("click", function(e){
    event.preventDefault();
    $(".js-panel-opener-size").removeClass("on");
    $("#mobile-vue-app").hide();
    $(this).toggleClass('on');
    hideTitle();
    $("#mobile-color-app").toggle();
    $(".other-colors--mobile").toggle();
  });
  $(".color-pattern .item").on("click", function(e){
    var src = $(this).find('img').attr("src");
    var className = "other";
    if ($(this).hasClass('white')) {
      className = "white";
    }
    $(".js-panel-opener-color img")
      .attr("src",src)
      .removeAttr("class")
      .addClass(className);
  })
  // select options
  $(".mobile-variants-options-name").on("click", function(e){
    var target = $(this).data("target");
    // console.log(target);
    if ($(target).hasClass("hide")) {
      $(target)
        .removeClass("hide")
        .siblings('.mobile-variants-images')
        .addClass('hide');
    }else{
      $(target)
        .addClass('hide');
    }
    getVariantHeight();
    const isInitials = target === ".mobile-input-type"
    tshirt(isInitials); // TTT
  })
  // change variants
  $(".mobile-variants-options-value").on("click", function(e){
    var parent = $(this).data("class")+" .choose-item";
    var idx = $(this).data("index");
    $(parent).eq(idx).find(".with-soat-icon").click();
    $(this)
      .find(".variants-options-item")
      .addClass("active");
    $(this)
      .siblings('.mobile-variants-options-value')
      .find(".variants-options-item")
      .removeClass('active');
    var variant = Shopify.theme.product.getVariantFromOptionArray(mhProductJSON, getSelectedVariant())
    document.querySelectorAll("[data-product-price]").forEach(el => el.innerText = Shopify.formatMoney(variant.price))
  })
  // $(".first-product-items .choose-item").eq(1).find(".with-soat-icon").click()
  /*mobile initial*/
  var callLimit = 0;
  $("#mobile-input").on('keyup', function(e) {
    var val = $(this).val();
    // console.log(val)
   $("#input-type1").val(val).trigger('keyup')
  })

  // sync with fonts
  $(".mobile-choose-fonts").on('click',function () {
    $(this).addClass('active').siblings('.mobile-choose-fonts').removeClass('active');
    var idx = $(this).data("index");
    $(".choice-fonts .item").eq(idx).find("img").click()
  })
  // sync with fonts
  $(".mobile-choose-colors").on('click',function () {
    $(this).addClass('active').siblings('.mobile-choose-colors').removeClass('active');
    var idx = $(this).data("index");
    $(".choice-pattern .item").eq(idx).find("img").click()
  })
  //

  if(performance.navigation.type == 2)
  {
    // console.log("navigation");
    if ($("body").hasClass('template-product')){
      applyProperyData();
    }
      // console.log(performance.navigation.type);
  }

  // this is called update quantity items
  fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
    // console.log(data);
    $(".quick-cart__indicator-inner").html(data.item_count);
   });
})

// $("#Option1").val("Con risvolto").trigger("change")
// $("#variant-selector").val("40756421492932").change()
// $(".mh-product-form").serialize()

/*account pages*/
function registerFrom() {
  // V2: Shopify sign-in creates the account. Back on /account/login the customer would see the login form again.
  if (useSizesV2()) {
    signInV2(false, `${Shopify.routes.root}account`);
    return;
  }

  app.config = false;
  app.isSized = false;
  app.isLoggedIn = false;
  app.activeForm = "login";
  app.customer = "register";
  if (!app.redirect) {
    app.password="filatori";
  }
  app.open();

  app.registerHeader = "Nuovi clienti";
}
$(function () {
  // open login form for the product pages

  $("#requestRegisterFormButton").on("click", function(e){
    registerFrom();
  });

  // drawer login form
  $(".template-product li.header__icon.header__icon--account > a").on("click", function(e){
    if(!customerData.isLoggedIn){
      e.preventDefault();
      loginFrom();
    }
  });

  // register login form
  $(".register-toogle").on("click", function(e){
    if(!customerData.isLoggedIn){
      e.preventDefault();
      loginFrom();
      registerFrom();
    }
  });
  // validate
  $(".mh_appointment-top #customer_login").validate({
    rules: {
      "customer[password]": {
        required: true,
        minlength: 2
      },
      "customer[email]": {
        required: true,
        email: true
      }
    },
    messages: {
      name: {
        minlength: "Password required"
      },
      email: {
        email: "The email should be in the format: abc@domain.tld"
      }
    },
    submitHandler: function (form) { // for demo
      // console.log('valid form submitted'); // for demo
      // do other things for a valid form
      form.submit();
    }
  });
  // submit
  $(".mh_appointment-top .btn-submit").on("click", function(e){
    e.preventDefault();
    var is_any_error = !$("#ContactFormEmail").hasClass("error") && !$("#ContactFormPassword").hasClass("error");
    var is_any_values = !!$("#ContactFormEmail").val() && !!$("#ContactFormPassword").val();

    if(is_any_error && is_any_values ){
      storeLoggedIn();
      $(this).siblings('button').trigger("click");
    }

  });

  // retrieve login data after successful login
  // console.log("navigation");
  if ($("body").hasClass('template-product') && customerData.isLoggedIn){
    if (localStorage.getItem('login_success') == 'true') {
      var is_login_success = applyProperyData();
      // console.log(is_login_success);
      if(is_login_success){
        localStorage.removeItem('login_success');
      }
    }
  }

  // attach v-model to recovery email
  $("#RecoverEmail").on('keyup', function(e) {
    var val = $(this).val();
    // console.log(val)
    app.email = $(this).val()
  })

  //  change profile
  $(".change-password").on('click', function(event) {
    event.preventDefault();
    /* Act on the event */
    var self = this;
    var first_name = $("#login-form-nome").val();
    var last_name = $("#login-form-last_name").val();
    if (first_name && last_name && useSizesV2()) {
      updateProfileV2(self, first_name, last_name);
    } else if (first_name && last_name) {
      $(self).addClass('loading');
      $.ajax({
        type: 'POST',
        url: `http://themebuz.com/subscription/public/profile`,
        dataType: 'json',
        data:{
          id: customerData.id,
          first_name,
          last_name,
          phone: $("#login-form-phone").val()
        },
        success: function(res) {
          // console.log('customer profile updated successfully');
          // console.log(res);
          // window.location.reload();
          var prevId = getUserID();

          customerData = res.customer;
          customerData.isLoggedIn = true;
          $(".form-success").removeClass('hide');
          $(".form-error").addClass('hide');
          // V2 sizes belong to the customer, not to their name
          if (prevId !==  getUserID() && !useSizesV2()) {
            updateFirebase(prevId);
          } else {
            // console.log("id are same");
          }
          $(self).removeClass('loading');
          $("#login-form-phone").closest('.form-group').removeClass('show-error');
        },
        error: function(request, status, error) {
          // if it's not last one Move Along else update the cart number with the current quantity
          // console.log(request.responseText);
          // console.log("error");
          $(self).removeClass('loading');
          $("#login-form-phone").closest('.form-group').addClass('show-error');
          $(".form-success").addClass('hide');
          $(".form-error").removeClass('hide');
        }
      });
    } else {
      $("#CustomerPassword").attr('aria-invalid',true);
    }
  });

  $(".address-remove").on('click', function(event) {
    event.preventDefault();
    /* Act on the event */
    app.removeAddress= $(this).data("id");
    app.activeForm = "remove-size";
    app.open();
  });

  $("#login-form-phone").on('keyup',  function(event) {
    // event.preventDefault();
    /* Act on the event */
    var val = $(this).val();
    // console.log(val);
    $("#login-form-phone").closest('.form-group').removeClass('show-error');
    $(".form-success").addClass('hide');
    $(".form-error").addClass('hide');
    if (val.length) {
      $(".phone-icon-check").removeClass('hide');
    } else {
      $(".phone-icon-check").addClass('hide');
    }
  });

})

// V2 profile page save (customers/addresses): name only, phone is skipped (decision 4)
async function updateProfileV2(button, firstName, lastName) {
  $(button).addClass('loading');

  try {
    await window.FilatoriProfile.updateName(firstName, lastName);
  } catch (error) {
    console.error(error);
    $(button).removeClass('loading');
    $(".form-success").addClass('hide');
    $(".form-error").removeClass('hide');
    return;
  }

  customerData.first_name = firstName;
  customerData.last_name = lastName;
  customerData.name = firstName + ' ' + lastName;
  $(button).removeClass('loading');
  $(".form-success").removeClass('hide');
  $(".form-error").addClass('hide');
}

function updateFirebase(prevId) {
  var ref = db.collection("Dati Taglie").doc(prevId);
  var ref2 = db.collection("Dati Taglie").doc(getUserID());
  ref.get({source: 'server'})
  .then((thisDoc) => {
    // console.log("4444")
    
    // console.log(thisDoc.exists);
    if (thisDoc.exists) {
      thisDoc.ref.delete();
      // console.log(prevId);
      return true;
    }
    return false;
  })
  .then((config) => {
    if (config) {
      ref2.get()
      .then((thisDoc) => {
        for (const [key, value] of Object.entries(app.editSize)) {
            app.editSize[key].cliente.nome = `${customerData.first_name} ${customerData.last_name}`
            // console.log(value.cliente.nome);
          }
          ref2.set(app.editSize);
          // console.log("updated");
      })
      .catch((error) => {
        console.log(error);
      });
    }
  })
  .catch((error) => {
    console.log(error);
  });
}


// subscribe
function emailSubscribe( value = false ) {
  $.ajax({
      type: 'POST',
      url: `http://themebuz.com/subscription/public/subscribe/${customerData.id}`,
      dataType: 'json',
      data:{
        subscribe: value
      },
      success: function(res) {
        // console.log('customer subscription updated successfully');
        // console.log(res);
        localStorage.setItem('email_subscribe',true);

        window.location.reload();

      },
      error: function(request, status, error) {
        // if it's not last one Move Along else update the cart number with the current quantity
        console.log(request.responseText);
        console.log("error");
      }
    });
}
$(function () {
  $(".change-subscribe").on('click', function(event) {
    event.preventDefault();
    var input = $('[name="radio"]:checked');
    var value = $(input).data('subscribe')
    /* Act on the event */
    $(this).addClass('loading');

    // console.log(value)

    emailSubscribe(value);
  });
  $(".direct-unsubscribe").on('click', function(event) {
    event.preventDefault();
    emailSubscribe(false);
  });

  if ( localStorage.getItem('email_subscribe') === "true" ) {
    $("#EmailPreferenceCenter .form-success").removeClass('hide');
    localStorage.removeItem('email_subscribe');
  }
})


// filter by colour group
var colorGroup = new Vue({
  el: "#mh-color-group",
  delimiters: ["${", "}"],
  data: {
    products: [],
    productHandle
  },
  mounted(){
    $.get(`${Shopify.locale !== 'it' ? `` : '' }/collections/all?view=view-json`,function(data){
    // $.get(`${Shopify.locale !== 'it' ? `/${Shopify.locale}` : '' }/collections/all?view=view-json`,function(data){
        let products = JSON.parse(data);
        // console.log(JSON.parse(data))
        colorGroup.products = products.filter( p => p.group === colorGroupBy && p.group ).map(p => ({...p, url: `${Shopify.routes.root}${p.url.replace("/", "")}`}) )
        // console.log("Res Col:", colorGroup.products)
        
    })
  }
})

var colorGroupMobile = new Vue({
  el: "#mh-mobile-color-app",
  delimiters: ["${", "}"],
  data: {
    products: [],
    productHandle
  },
  mounted(){
    $.get(`${Shopify.locale !== 'it' ? `` : '' }/collections/all?view=view-json`,function(data){
    // $.get(`${Shopify.locale !== 'it' ? `/${Shopify.locale}` : '' }/collections/all?view=view-json`,function(data){
        let products = JSON.parse(data);
        // console.log(JSON.parse(data))
        colorGroupMobile.products = products.filter( p => p.group === colorGroupBy && p.group ).map(p => ({...p, url: `${Shopify.routes.root}${p.url.replace("/", "")}`}) )
    })
  }
})


function tttlala() {
  try {
    console.log("Load more")
    if (location.href.includes("/collections/")) {
      const prevCollectionScrollY = sessionStorage.getItem("collection_scroll")
      sessionStorage.removeItem("collection_scroll")
      if (!prevCollectionScrollY) return
      const parts = prevCollectionScrollY.split("__")
      if (!location.href.includes(parts?.[2])) {
        return
      }
  
      setTimeout(() => {
        window.scrollTo(0, Number(prevCollectionScrollY.split("__")[0]))
        console.log("Revert scroll", prevCollectionScrollY.split("__")[0])
      }, 10)
    }
    
  } catch (error) {
    console.error(error)
  }
}

if (location.href.includes("/collections/")) {

  document.addEventListener("click", function (e) {
    const link = e.target.closest("a");
    if (!link || !link.href) return;
    if (link.href.includes("/products/")) {
      sessionStorage.setItem("collection_scroll", String(window.scrollY + "__" + link.href.split("/").at(-1) + "__" + location.href.split("/").at(-1)));
    }
  });
}